module.exports = __webpack_public_path__ + "img/Asset-206-100.9d53c24b.jpg";